/* @generated */
/* empty css                                      *//* empty css                                     */import { createRuntimeFn } from "@vanilla-extract/recipes/createRuntimeFn";
var gapVar = "var(--dig-8ezyai0_4-3-1)";
var arbitraryChildrenOffsetVar = "var(--dig-8ezyai1_4-3-1)";
var verticalAlignmentVar = "var(--dig-8ezyai2_4-3-1)";
var accessoryVerticalAlignmentVar = "var(--dig-8ezyai3_4-3-1)";
var childrenVerticalAlignmentVar = "var(--dig-8ezyai4_4-3-1)";
var inlineRecipe = createRuntimeFn({ defaultClassName: "dig-8ezyai5_4-3-1", variantClassNames: { isInline: { true: "dig-8ezyai6_4-3-1", false: "dig-8ezyai7_4-3-1" } }, defaultVariants: { isInline: false }, compoundVariants: [] });
var root = "dig-8ezyai8_4-3-1";
var childrenOffset = "dig-8ezyai9_4-3-1";
var accessory = "dig-8ezyaia_4-3-1";
var startAccessory = "dig-8ezyaib_4-3-1";
var endAccessory = "dig-8ezyaic_4-3-1";
var children = "dig-8ezyaid_4-3-1";
export {
  accessory,
  accessoryVerticalAlignmentVar,
  arbitraryChildrenOffsetVar,
  children,
  childrenOffset,
  childrenVerticalAlignmentVar,
  endAccessory,
  gapVar,
  inlineRecipe,
  root,
  startAccessory,
  verticalAlignmentVar
};
